import { IntentToggleOptions } from '@eventbrite/global-nav';
import { useShowAttendeeCreatorToggle } from '../../../hooks/useStatsig';

interface IntentToggleStateProps {
    show: boolean;
    activeOption: IntentToggleOptions;
}

export const useIntentToggle = (
    isHomePage: boolean,
): IntentToggleStateProps => {
    const showToggle = useShowAttendeeCreatorToggle();
    return {
        show: isHomePage ? showToggle : false,
        activeOption: IntentToggleOptions.FIND_EVENTS,
    };
};
